import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { FABProvider } from './contexts/FABContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { router } from './routes';
import { Toaster } from 'react-hot-toast';
import UpdateBanner from './components/layout/UpdateBanner';
import ErrorBoundary from './components/common/ErrorBoundary';
import MFAWrapper from './components/auth/MFAWrapper';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <MFAWrapper>
              <SidebarProvider>
                <FABProvider>
                  <NotificationProvider>
                    <RouterProvider router={router} />
                  </NotificationProvider>
                </FABProvider>
              </SidebarProvider>
            </MFAWrapper>
          </AuthProvider>
          <Toaster />
          <UpdateBanner />
        </LanguageProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
